// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AutoSubmitController from './auto_submit_controller'

import CopyValueController from './copy_value_controller'

import DialogController from './dialog_controller'

import FlashController from './flash_controller'

import SearchController from './search_controller'

import HighlightController from './highlight_controller'

import PasswordValidatorController from './password_validator_controller'

import ProgressBarController from './progress_bar_controller'
application.register('auto-submit', AutoSubmitController)
application.register('copy-value', CopyValueController)
application.register('dialog', DialogController)
application.register('flash', FlashController)
application.register('search', SearchController)
application.register('highlight', HighlightController)
application.register('password-validator', PasswordValidatorController)
application.register('progress-bar', ProgressBarController)
